// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__63OKw","Label":"Input_Label__30svx","InputElement":"Input_InputElement__1e3Do","Invalid":"Input_Invalid__2NZiW"};